import React from 'react';
import { inject, observer } from 'mobx-react';

import ContentEditable from 'react-contenteditable';

import { fieldValue } from 'sdc-data-models';

import './ContentEditable.scss';

export var TextValueEditor = inject('languagesStore', 'editingStore')(observer(function (_ref) {
  var languagesStore = _ref.languagesStore,
      store = _ref.editingStore,
      field = _ref.field,
      locale = _ref.locale,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className,
      editStyle = _ref.editStyle;

  var currentValue = languagesStore.labelFrom(fieldValue(store.snapshot, field.key), locale) || '';

  return React.createElement(ContentEditable, { className: 'content-editable ' + className,
    style: editStyle,
    html: currentValue,
    onFocus: store.selectField(field, locale),
    onChange: store.updateField(field, locale),
    onBlur: store.updateField(field, locale, true)
  });
}));